import React, { memo } from 'react'

import OverviewMainPanel from '../../../components/overview/OverviewMainPanel'

const OverviewMainPanelWrapper = (props) => {
  return <OverviewMainPanel {...props} />
}

export default memo(OverviewMainPanelWrapper)
